import React from 'react';

// Draw icons as paths, never font glyphs that can become mobile emoji.
export const iconNames = ['arrow-right', 'arrow-left', 'chevron-down', 'spark', 'sun', 'people', 'home', 'heart', 'infinity', 'check', 'plus', 'info', 'expand', 'collapse'];
const paths = {
  'arrow-right': 'M4 12h16m-6-6 6 6-6 6',
  'arrow-left': 'M20 12H4m6-6-6 6 6 6',
  'chevron-down': 'm6 9 6 6 6-6',
  spark: 'M12 2v20M2 12h20M5 5l14 14M5 19 19 5',
  sun: 'M12 1v3m0 16v3M1 12h3m16 0h3M4 4l2 2m12 12 2 2M4 20l2-2M18 6l2-2',
  people: 'M3 21v-2a5 5 0 0 1 10 0v2m3-7a5 5 0 0 1 5 5v2',
  home: 'M3 11 12 3l9 8M5 10v11h5v-7h4v7h5V10',
  heart: 'M20.8 4.6a5.5 5.5 0 0 0-7.8 0L12 5.7l-1.1-1.1a5.5 5.5 0 0 0-7.8 7.8L12 21l8.8-8.6a5.5 5.5 0 0 0 0-7.8Z',
  infinity: 'M12 12C9 6 3 6 3 12s6 6 9 0 9-6 9 0-6 6-9 0Z',
  check: 'm5 12 4 4L19 6',
  plus: 'M12 4v16M4 12h16',
  info: 'M12 11v6M12 7v.1',
  expand: 'M9 3H3v6m12-6h6v6M3 15v6h6m12-6v6h-6',
  collapse: 'M3 9h6V3m6 0v6h6M9 21v-6H3m12 6v-6h6'
};
export default function Icon({ name, className = '', filled = false }) {
  return <svg className={`icon ${className}`.trim()} data-icon={name} viewBox="0 0 24 24" width="1em" height="1em" fill={filled ? 'currentColor' : 'none'} stroke="currentColor" strokeWidth="1.7" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true" focusable="false">
    {name === 'sun' && <circle cx="12" cy="12" r="5" />}
    {name === 'info' && <circle cx="12" cy="12" r="10" />}
    {name === 'people' && <><circle cx="8" cy="7" r="4" /><path d="M16 3a4 4 0 0 1 0 8" /></>}
    <path d={paths[name] || paths.spark} />
  </svg>;
}
